export default __webpack_public_path__ + "static/api-8b8e36279951f3ce302da4a04875ac10.png";